import type { FC } from 'react';
import { Spinner } from '@components/ui/spinner';
import { Tooltip, TooltipContent, TooltipTrigger } from '@components/ui/tooltip';
import clsx from 'clsx';

import { SavedViewRow } from '../components/SavedViewRow';

export interface SavedViewNavRow {
  id: string;
  name: string;
  count?: number;
  loading?: boolean;
  active: boolean;
  onSelect: () => void;
}

interface SavedViewsNavSectionProps {
  rows: SavedViewNavRow[];
  isCollapsed?: boolean;
}

export const SavedViewsNavSection: FC<SavedViewsNavSectionProps> = ({ rows, isCollapsed }) =>
  isCollapsed ? (
    <div className="mt-2 mb-4 flex flex-col items-center gap-1">
      <p className="text-info-500 text-[10px] font-semibold tracking-wide uppercase">Views</p>
      {rows.map(({ id, name, count, loading, active, onSelect }) => (
        <Tooltip key={id}>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={onSelect}
              aria-current={active ? 'true' : undefined}
              aria-label={name}
              className={clsx(
                'bg-info-900 inline-flex h-5 min-w-8 items-center justify-center gap-x-1 rounded-full px-1 text-xs',
                active ? 'text-white' : 'text-info-300 hover:bg-info-700 hover:text-white',
              )}
            >
              {Number.isFinite(count) ? count : '–'}
              {loading && <Spinner className="size-3" />}
            </button>
          </TooltipTrigger>
          <TooltipContent side="right" className="bg-info-900 rounded-[5px] px-[11px] py-2 text-xs text-white">
            {name}
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  ) : (
    <div className="mt-2 mb-4 pl-2">
      <p className="text-info-500 px-2 text-xs font-semibold tracking-wide uppercase">My Filtered Views</p>
      <div className="mt-1 space-y-1">
        {rows.map(({ id, name, count, loading, active, onSelect }) => (
          <SavedViewRow key={id} name={name} count={count} loading={loading} active={active} onClick={onSelect} />
        ))}
      </div>
    </div>
  );
